import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from 'components/Buttons';
import MBCheckbox from 'components/Elements/MBCheckbox';
import MBTextField from 'components/Forms/MBTextField/MBTextField';
import TypographyComponent from 'components/Typography/Typography';
import { theme } from 'theme';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';
import { ModalPlacement } from './types';

const getModalStyles = (modalPlacement: ModalPlacement) => {
  switch (modalPlacement) {
    case ModalPlacement.Top:
      return css`
        transform: translateY(-100%);
        margin-top: -${pxToEm(60)};
        transform-origin: bottom center;
      `;
    case ModalPlacement.Bottom:
      return css`
        margin-top: ${pxToEm(1)};
      `;
    default:
      return '';
  }
};

export const ContactRepModal = styled.div<{
  isOpen: boolean;
  modalPlacement: ModalPlacement;
  isFormSent: boolean;
  modalXOffset?: number;
  isEmpty?: boolean;
  isError?: boolean;
}>`
  width: ${pxToEm(276)};
  position: absolute;
  z-index: 5;
  padding: ${pxToEm(16)};
  background-color: ${palette.common.white};
  border-radius: ${pxToEm(20)};
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  ${({ modalPlacement }) => getModalStyles(modalPlacement)};
  ${({ modalXOffset }) =>
    modalXOffset &&
    css`
      margin-left: ${pxToEm(modalXOffset)};
    `};
  box-shadow: ${theme.shadows[3]};
  min-height: ${pxToEm(400)};
  ${({ isFormSent, isEmpty, isOpen, isError }) =>
    (isEmpty || isFormSent || isError) &&
    isOpen &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

export const ContactRepModalHeader = styled(TypographyComponent)``;

export const ContactRepModalBody = styled.div`
  margin-top: ${pxToEm(20)};
  margin-bottom: ${pxToEm(24)};
`;

export const ContactRepModalCheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToEm(16)};
  margin-top: ${pxToEm(20)};
  margin-bottom: ${pxToEm(16)};
`;

export const ContactRepModalCheckbox = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${pxToEm(12)};
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const AddMessageButton = styled(Button)`
  gap: ${pxToEm(12)};

  &:hover {
    opacity: 0.8;
    color: inherit;
  }
`;

export const ContactRepModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${pxToEm(12)};
`;

export const ContactRepModalTextField = styled(MBTextField)``;

export const Checkbox = styled(MBCheckbox)`
  &.Mui-checked {
    border: 2px solid ${palette.primary.main} !important;
  }
`;

export const StatusMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${pxToEm(8)};
  text-align: center;
  height: 100%;
`;
